import isNullOrEmpty from 'util/functions/isNullOrEmpty';
import useAuth from './useAuth';

const useSettingInvoice = () => {
  const { company, userCompany } = useAuth();

  const isEnableInvoice = () => {
    if (!isNullOrEmpty(userCompany, 'object')) {
      return userCompany.settings?.enableInvoice;
    }

    return company.settings?.enableInvoice;
  };

  const enableInvoice = isEnableInvoice();

  return { enableInvoice };
};

export default useSettingInvoice;
